import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { EditableText, EditableSection, useAdmin } from './AdminContentEditor';

export const HeroSection = () => {
  const { theme } = useTheme();
  const { isEditMode } = useAdmin();
  
  const content = (
    <section 
      className="min-h-screen flex flex-col items-center justify-center px-4 pt-10 pb-16 relative"
      aria-labelledby="hero-heading"
    >
      <motion.div 
        className="relative z-10 text-center max-w-7xl mx-auto w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* Instagram-style location tag - bigger and floating */}
        <motion.div
          className="flex items-center justify-center"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
        >
          <h1 id="hero-heading" className="sr-only">Data Dreaming - somewhere data dreaming</h1>
          <motion.div
            className="inline-flex items-center gap-2 sm:gap-4 px-4 sm:px-8 py-3 sm:py-4 rounded-full backdrop-blur-md"
            style={{
              background: 'rgba(0, 0, 0, 0.7)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
            }}
            animate={{ 
              y: [0, -10, 0],
              rotate: [-1, 1, -1],
            }}
            transition={{ 
              duration: 4, 
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          >
            <MapPin className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white" strokeWidth={2.5} aria-hidden="true" />
            <EditableText
              sectionId="hero"
              field="title"
              defaultValue="somewhere data dreaming"
              className="text-white font-semibold text-lg sm:text-2xl md:text-3xl lg:text-4xl tracking-wide"
              as="span"
            />
          </motion.div>
        </motion.div>
      </motion.div>
      
      {/* Scroll indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
      >
        <motion.div
          className={`w-6 h-10 rounded-full border-2 flex items-start justify-center p-2 ${
            theme === 'sunrise' ? 'border-white/40' : 'border-emerald-300/40'
          }`}
          animate={{ y: [0, 5, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <motion.div
            className={`w-1.5 h-3 rounded-full ${
              theme === 'sunrise' ? 'bg-white/60' : 'bg-emerald-300/60'
            }`}
            animate={{ y: [0, 8, 0], opacity: [1, 0.3, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </motion.div>
      </motion.div>
    </section>
  );

  if (isEditMode) {
    return <EditableSection sectionId="hero">{content}</EditableSection>;
  }

  return content;
};

export default HeroSection;
